export async function getAllFileEntries(
  dataTransferItemList: DataTransferItemList,
): Promise<File[]> {
  let fileEntries = [];
  // Use BFS to traverse entire directory/file structure
  let queue: FileSystemEntry[] = [];
  // Unfortunately dataTransferItemList is not iterable i.e. no forEach
  for (let i = 0; i < dataTransferItemList.length; i++) {
    // Note webkitGetAsEntry a non-standard feature and may change
    // Usage is necessary for handling directories
    const entry = dataTransferItemList[i].webkitGetAsEntry();
    if (entry) {
      queue.push(entry);
    }
  }
  while (queue.length > 0) {
    let entry = queue.shift();
    if (entry) {
      if (entry.isFile) {
        fileEntries.push(entry);
      } else if (entry.isDirectory) {
        queue.push(
          ...(await readAllDirectoryEntries(
            (entry as FileSystemDirectoryEntry).createReader(),
          )),
        );
      }
    }
  }
  const files: File[] = [];
  for (const entry of fileEntries) {
    const f = await readFileFromEntry(entry as FileSystemFileEntry);
    files.push(f);
  }

  return files;
}

// Get all the entries (files or sub-directories) in a directory
// by calling readEntries until it returns empty array
async function readAllDirectoryEntries(
  directoryReader: FileSystemDirectoryReader,
) {
  let entries = [];
  let readEntries = await readEntriesPromise(directoryReader);
  while (readEntries.length > 0) {
    entries.push(...readEntries);
    readEntries = await readEntriesPromise(directoryReader);
  }
  return entries;
}

// Wrap readEntries in a promise to make working with readEntries easier
// readEntries will return only some of the entries in a directory
// e.g. Chrome returns at most 100 entries at a time
async function readEntriesPromise(directoryReader: FileSystemDirectoryReader) {
  return await new Promise(
    (resolve: (entries: FileSystemEntry[]) => void, reject) => {
      directoryReader.readEntries(resolve, reject);
    },
  );
}

async function readFileFromEntry(entry: FileSystemFileEntry): Promise<File> {
  return new Promise((resolve, reject) => {
    entry.file(resolve, reject);
  });
}
